export const navigateToTermsOfService = () => {
  // TODO: https://asiga.atlassian.net/browse/MESH-1021 use "https://genira.com/terms-of-service/"
  window.open("https://www.asiga.com/terms-conditions-genira/", "_blank", "noopener");
};

export const navigateToPrivacyPolicy = () => {
  // TODO: https://asiga.atlassian.net/browse/MESH-1021 use "https://genira.com/privacy-policy/"
  window.open("https://www.asiga.com/privacy-policy/", "_blank", "noopener");
};

export const navigateToAiUsagePolicy = () => {
  window.open("https://genira.com/data-processing-agreement/", "_blank", "noopener");
};

export const navigateToCookiePolicy = () => {
  // TODO: https://asiga.atlassian.net/browse/MESH-1021
  // use "https://genira.com/privacy-policy/#2-what-information-do-we-collect-and-how-is-it-collected"
  window.open("https://www.asiga.com/privacy-policy/#cookie-policy", "_blank", "noopener");
};
